import React, { FunctionComponent, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';

const Hr = styled.hr`
  border: none;
  height: 1px;
  width: 100%;
  color: rgba(104,112,146,0.62);
  background-color: rgba(104,112,146,0.62);
  margin: unset;
`;

const HrLight = styled.hr`
  border: none;
  height: 1px;
  width: 100%;
  color: rgba(0,0,0,0.08);
  background-color: rgba(0,0,0,0.08);
  margin: unset;
`;

const HorizontalRule: FunctionComponent<any> = ({
  ...rest
}: any) => {
  const themeContext = useContext(ThemeContext);
  return themeContext.mode === 'dark' ? <Hr {...rest} /> : <HrLight {...rest} />;
};

export default HorizontalRule;
